import { apiService } from "./api";

export const orderService = {
  // ===== CORE ORDER OPERATIONS =====

  // Get all orders
  getAllOrders: async (params = {}) => {
    try {
      const response = await apiService.get("/orders", { params });
      return response.data;
    } catch (error) {
      console.error("Error fetching orders:", error);
      throw new Error(`Failed to fetch orders: ${error.message}`);
    }
  },

  // Get order by ID
  getOrderById: async (orderId) => {
    try {
      const response = await apiService.get(`/orders/${orderId}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching order:", error);
      if (error.response?.status === 404) {
        throw new Error("Order not found");
      }
      throw new Error(`Failed to fetch order: ${error.message}`);
    }
  },

  // Create order with enhanced error handling
  createOrder: async (orderData) => {
    try {
      const token =
        sessionStorage.getItem("token") || sessionStorage.getItem("token");

      if (!token) {
        throw new Error(
          "Authentication token is missing. Please log in again."
        );
      }

      // FIXED: Process exam selections correctly
      // const processedExams = orderData.exams
      //   .map((exam) => {
      //     console.log("Processing exam in orderService:", exam);

      //     // FIXED: Handle exams with valid database IDs
      //     if (exam.exam_type_id && exam.exam_type_id > 0) {
      //       console.log(`Using exam_type_id: ${exam.exam_type_id}`);
      //       return {
      //         exam_type_id: parseInt(exam.exam_type_id),
      //         notes: exam.notes || null,
      //       };
      //     }

      //     // FIXED: Handle exams with ID field (from frontend)
      //     if (exam.id && exam.id > 0 && !exam.is_custom) {
      //       console.log(`Converting exam.id to exam_type_id: ${exam.id}`);
      //       return {
      //         exam_type_id: parseInt(exam.id),
      //         notes: exam.notes || null,
      //       };
      //     }

      //     // FIXED: Handle custom exams properly
      //     if (
      //       exam.is_custom ||
      //       exam.isCustom ||
      //       (exam.name && (!exam.id || exam.id <= 0))
      //     ) {
      //       console.log(`Processing custom exam: ${exam.name}`);
      //       return {
      //         exam_type_id: null,
      //         name: exam.name,
      //         description: exam.description || "",
      //         duration: exam.duration || null,
      //         notes: exam.notes || null,
      //         is_custom: true,
      //       };
      //     }

      //     // FIXED: Handle string IDs that need conversion
      //     if (typeof exam.id === "string" && exam.id.startsWith("temp_")) {
      //       console.log(`Processing temp exam: ${exam.name}`);
      //       return {
      //         exam_type_id: null,
      //         name: exam.name,
      //         description: exam.description || "",
      //         is_custom: true,
      //       };
      //     }

      //     console.error("Unhandled exam format:", exam);
      //     return null;
      //   })
      //   .filter(Boolean); // Remove null entries
        
      // console.log("Final processed exams:", processedExams);
      const processedExams = orderData.exams || [];

      // Transform the order data
      const transformedData = {
        ...orderData,
        patient_id: orderData.patient_id,
        ordering_physician_id: orderData.ordering_physician_id || null,
        place_of_service: orderData.place_of_service || "Home",
        facility_id: orderData.facility_id || 1,
        ordering_health_company: orderData.ordering_health_company || "",
        scheduled_date: orderData.scheduled_date || null,
        scheduled_time: orderData.scheduled_time || null,
        medical_professional_id:
          typeof orderData.medical_professional_id === "number" &&
          orderData.medical_professional_id > 0
            ? orderData.medical_professional_id
            : null,
        special_notes: orderData.special_notes || "",
        exams: processedExams, // Use the processed exams
        diagnoses: orderData.diagnoses || [],
      };


      const response = await apiService.post("/orders", transformedData, {
        headers: { Authorization: `Bearer ${token}` },
      });

      return response.data;
    } catch (err) {
      console.error("Error in createOrder:", err);
      throw err;
    }
  },

  // FIXED: Enhanced update order method with proper diagnosis handling
  updateOrder: async (orderId, updateData) => {
    try {

      // FIXED: Process and validate the update data before sending
      const processedUpdateData = { ...updateData };

      // FIXED: Ensure diagnosis data is properly formatted
      if (processedUpdateData.diagnoses) {

        processedUpdateData.diagnoses = processedUpdateData.diagnoses
          .map((diagnosis, index) => {

            // Handle different possible data structures
            let diagnosisId = null;
            let isPrimary = index === 0;

            if (typeof diagnosis === "object") {
              diagnosisId = diagnosis.diagnosis_id || diagnosis.id;
              isPrimary = diagnosis.hasOwnProperty("primary")
                ? diagnosis.primary
                : index === 0;
            } else {
              diagnosisId = diagnosis;
            }

            // Validate diagnosis ID
            if (!diagnosisId || diagnosisId <= 0) {
              console.error("Invalid diagnosis ID:", diagnosis);
              return null;
            }

            const formatted = {
              diagnosis_id: parseInt(diagnosisId),
              primary: isPrimary,
            };

            return formatted;
          })
          .filter(Boolean); // Remove null entries


        // Additional validation
        if (
          processedUpdateData.diagnoses.length === 0 &&
          updateData.diagnoses.length > 0
        ) {
          throw new Error(
            "No valid diagnoses found. Please check your diagnosis selections."
          );
        }
      }

      // FIXED: Ensure exam data is properly formatted
      if (processedUpdateData.exams) {

        processedUpdateData.exams = processedUpdateData.exams
          .map((exam) => {

            let examTypeId = null;

            if (typeof exam === "object") {
              examTypeId = exam.exam_type_id || exam.id;
            } else {
              examTypeId = exam;
            }

            if (!examTypeId || examTypeId <= 0) {
              console.error("Invalid exam type ID:", exam);
              return null;
            }

            const formatted = {
              exam_type_id: parseInt(examTypeId),
            };

            return formatted;
          })
          .filter(Boolean); // Remove null entries

      }

      // FIXED: Clean up other fields
      if (processedUpdateData.scheduled_date === "") {
        processedUpdateData.scheduled_date = null;
      }
      if (processedUpdateData.scheduled_time === "") {
        processedUpdateData.scheduled_time = null;
      }
      if (processedUpdateData.medical_professional_id === "") {
        processedUpdateData.medical_professional_id = null;
      }


      const response = await apiService.put(
        `/orders/${orderId}/update`,
        processedUpdateData
      );

      return response.data;
    } catch (error) {
      console.error("=== UPDATE ERROR ===");
      console.error("Error updating order:", error);
      console.error("Error response:", error.response?.data);

      if (error.response?.status === 404) {
        throw new Error("Order not found");
      } else if (error.response?.status === 403) {
        throw new Error("You don't have permission to edit this order");
      } else if (error.response?.status === 400) {
        const detail = error.response.data?.detail || "";
        if (detail.includes("diagnosis")) {
          throw new Error(`Diagnosis update failed: ${detail}`);
        } else if (detail.includes("exam")) {
          throw new Error(`Exam update failed: ${detail}`);
        }
        throw new Error(detail || "Failed to update order");
      }
      throw new Error(`Failed to update order: ${error.message}`);
    }
  },

  // FIXED: Add a specific method for diagnosis updates if needed
  updateOrderDiagnoses: async (orderId, diagnoses) => {
    try {

      // Format diagnoses properly
      const formattedDiagnoses = diagnoses.map((diagnosis, index) => {
        const diagnosisId = diagnosis.diagnosis_id || diagnosis.id;

        if (!diagnosisId || diagnosisId <= 0) {
          throw new Error(`Invalid diagnosis ID: ${diagnosisId}`);
        }

        return {
          diagnosis_id: parseInt(diagnosisId),
          primary: index === 0, // First diagnosis is primary
        };
      });


      const updateData = {
        diagnoses: formattedDiagnoses,
      };

      return await orderService.updateOrder(orderId, updateData);
    } catch (error) {
      console.error("Error updating order diagnoses:", error);
      throw new Error(`Failed to update diagnoses: ${error.message}`);
    }
  },

  // Extended update order with force edit capability - KEEP FOR ADMIN FEATURES
  updateOrderExtended: async (orderId, updateData, forceEdit = false) => {
    try {

      const params = forceEdit ? { force_edit: true } : {};

      const response = await apiService.put(
        `/orders/${orderId}/update-extended`,
        updateData,
        { params }
      );

      return response.data;
    } catch (error) {
      console.error("Error updating order (extended):", error);

      // Enhanced error handling for different scenarios
      if (error.response?.status === 400) {
        const detail = error.response.data?.detail || "";
        if (detail.includes("cannot be edited")) {
          if (detail.includes("force_edit=true")) {
            throw new Error(
              "This order requires force edit mode. Only administrators can force edit orders in this status."
            );
          } else {
            throw new Error(
              "This order cannot be edited in its current status. Contact an administrator if changes are needed."
            );
          }
        }
      } else if (error.response?.status === 403) {
        throw new Error("You don't have permission to edit this order");
      } else if (error.response?.status === 404) {
        throw new Error("Order not found");
      }

      throw new Error(`Failed to update order: ${error.message}`);
    }
  },

  // Update order status
  updateOrderStatus: async (orderId, statusData) => {
    try {
      const response = await apiService.put(
        `/orders/${orderId}/status`,
        statusData
      );
      return response.data;
    } catch (error) {
      console.error("Error updating order status:", error);
      throw new Error(`Failed to update order status: ${error.message}`);
    }
  },

  // FIXED: Enhanced assign medical professional method
  assignMedicalProfessional: async (orderId, professionalId) => {
    try {

      const response = await apiService.put(
        `/orders/${orderId}/assign-medical-professional`,
        null, // No body needed
        { params: { professional_id: professionalId } } // Send as query parameter
      );

      return response.data;
    } catch (error) {
      console.error("Error assigning medical professional:", error);

      // Enhanced error handling
      if (error.response?.status === 404) {
        if (error.response.data?.detail?.includes("Order not found")) {
          throw new Error("Order not found");
        } else if (
          error.response.data?.detail?.includes(
            "Medical professional not found"
          )
        ) {
          throw new Error("Selected medical professional not found");
        }
      } else if (error.response?.status === 400) {
        const detail = error.response.data?.detail;
        if (detail?.includes("not active")) {
          throw new Error("Selected medical professional is not active");
        } else if (detail?.includes("required")) {
          throw new Error("Medical professional selection is required");
        }
      } else if (error.response?.status === 403) {
        throw new Error(
          "You don't have permission to assign this medical professional"
        );
      } else if (error.response?.status === 422) {
        // Validation error
        const detail = error.response.data?.detail;
        if (Array.isArray(detail)) {
          const errorMessages = detail
            .map((err) => err.msg || err.message)
            .join(", ");
          throw new Error(`Validation error: ${errorMessages}`);
        } else {
          throw new Error(`Validation error: ${detail || "Invalid request"}`);
        }
      }

      throw new Error(
        `Failed to assign medical professional: ${error.message}`
      );
    }
  },

  // ===== PATIENT OPERATIONS =====

  getPatients: async (search = "", skip = 0, limit = 100) => {
    try {
      const params = { skip, limit };
      if (search && search.trim()) {
        params.search = search.trim();
      }

      const response = await apiService.get("/patients", { params });

      return Array.isArray(response.data) ? response.data : [];
    } catch (error) {
      console.error("Error fetching patients:", error);

      // Enhanced error handling with fallback
      if (error.response?.status === 404 || error.response?.status === 500) {
        console.warn("Patient endpoint unavailable, using fallback data");
        return orderService._getFallbackPatients(search);
      }

      throw new Error(`Failed to fetch patients: ${error.message}`);
    }
  },

  updateExamType: async (examTypeId, examData) => {
    try {
      const response = await apiService.put(
        `/exam-types/${examTypeId}`,
        examData
      );
      return response.data;
    } catch (error) {
      console.error("Error updating exam type:", error);
      throw new Error(`Failed to update exam type: ${error.message}`);
    }
  },

  createPatient: async (patientData) => {
    try {

      // Enhanced validation
      const requiredFields = [
        "first_name",
        "last_name",
        "address",
        "city",
        "state",
        "zip_code",
      ];
      const missingFields = requiredFields.filter(
        (field) => !patientData[field]?.trim()
      );

      if (missingFields.length > 0) {
        throw new Error(`Missing required fields: ${missingFields.join(", ")}`);
      }

      // Validate ZIP code format
      if (
        patientData.zip_code &&
        !/^\d{5}(-\d{4})?$/.test(patientData.zip_code.trim())
      ) {
        throw new Error("ZIP code must be in format 12345 or 12345-6789");
      }

      // Validate email if provided
      if (
        patientData.email &&
        !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(patientData.email)
      ) {
        throw new Error("Invalid email format");
      }

      // Clean and format the data
      const cleanedData = {
        ...patientData,
        first_name: patientData.first_name.trim(),
        last_name: patientData.last_name.trim(),
        address: patientData.address.trim(),
        city: patientData.city.trim(),
        state: patientData.state.trim().toUpperCase(),
        zip_code: patientData.zip_code.trim(),
        phone_number: patientData.phone_number?.trim() || null,
        email: patientData.email?.trim().toLowerCase() || null,
        address_notes: patientData.address_notes?.trim() || null,
        medical_record_number:
          patientData.medical_record_number?.trim() || null,
        emergency_contact_name:
          patientData.emergency_contact_name?.trim() || null,
        emergency_contact_phone:
          patientData.emergency_contact_phone?.trim() || null,
      };

      // Handle insurance information
      if (cleanedData.insurance_information) {
        try {
          if (cleanedData.insurance_information.trim().startsWith("{")) {
            cleanedData.insurance_info = JSON.parse(
              cleanedData.insurance_information
            );
          } else {
            cleanedData.insurance_info = cleanedData.insurance_information;
          }
        } catch (e) {
          cleanedData.insurance_info = cleanedData.insurance_information;
        }
        delete cleanedData.insurance_information;
      }

      const response = await apiService.post("/patients", cleanedData);
      return response.data;
    } catch (error) {
      console.error("Error creating patient:", error);

      // Enhanced error messages
      if (error.response?.status === 409) {
        throw new Error("A patient with this information already exists");
      } else if (error.response?.status === 422) {
        const details = error.response.data?.detail;
        if (Array.isArray(details)) {
          const errorMessages = details.map((err) => err.msg).join(", ");
          throw new Error(`Validation error: ${errorMessages}`);
        } else {
          throw new Error(`Validation error: ${details || "Invalid data"}`);
        }
      } else if (error.response?.status === 400) {
        throw new Error(error.response.data?.detail || "Invalid patient data");
      } else if (
        error.message.startsWith("Missing required fields") ||
        error.message.includes("ZIP code") ||
        error.message.includes("Invalid email")
      ) {
        throw error; // Re-throw validation errors as-is
      }

      throw new Error(`Failed to create patient: ${error.message}`);
    }
  },

  getPatientById: async (patientId) => {
    try {
      const response = await apiService.get(`/patients/${patientId}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching patient:", error);

      if (error.response?.status === 404) {
        throw new Error("Patient not found");
      }

      throw new Error(`Failed to fetch patient: ${error.message}`);
    }
  },

  updatePatient: async (patientId, patientData) => {
    try {

      // Clean and validate the data similar to create
      const cleanedData = { ...patientData };

      // Clean string fields
      Object.keys(cleanedData).forEach((key) => {
        if (typeof cleanedData[key] === "string" && cleanedData[key] !== null) {
          cleanedData[key] = cleanedData[key].trim();
          // Remove empty strings (but keep nulls)
          if (cleanedData[key] === "") {
            cleanedData[key] = null;
          }
        }
      });

      // Handle insurance information
      if (cleanedData.insurance_information !== undefined) {
        try {
          if (
            cleanedData.insurance_information &&
            cleanedData.insurance_information.trim().startsWith("{")
          ) {
            cleanedData.insurance_info = JSON.parse(
              cleanedData.insurance_information
            );
          } else {
            cleanedData.insurance_info = cleanedData.insurance_information;
          }
        } catch (e) {
          cleanedData.insurance_info = cleanedData.insurance_information;
        }
        delete cleanedData.insurance_information;
      }

      const response = await apiService.put(
        `/patients/${patientId}`,
        cleanedData
      );
      return response.data;
    } catch (error) {
      console.error("Error updating patient:", error);

      if (error.response?.status === 404) {
        throw new Error("Patient not found");
      } else if (error.response?.status === 409) {
        throw new Error("Update would create a duplicate record");
      } else if (error.response?.status === 422) {
        const details = error.response.data?.detail;
        if (Array.isArray(details)) {
          const errorMessages = details.map((err) => err.msg).join(", ");
          throw new Error(`Validation error: ${errorMessages}`);
        } else {
          throw new Error(`Validation error: ${details || "Invalid data"}`);
        }
      }

      throw new Error(`Failed to update patient: ${error.message}`);
    }
  },

  deletePatient: async (patientId) => {
    try {
      const response = await apiService.delete(`/patients/${patientId}`);
      return response.data;
    } catch (error) {
      console.error("Error deleting patient:", error);

      if (error.response?.status === 404) {
        throw new Error("Patient not found");
      } else if (error.response?.status === 409) {
        throw new Error("Cannot delete patient with associated orders");
      }

      throw new Error(`Failed to delete patient: ${error.message}`);
    }
  },

  searchPatients: async (searchQuery, limit = 50) => {
    try {
      const params = { q: searchQuery, limit };
      const response = await apiService.get("/patients/search", { params });
      return response.data;
    } catch (error) {
      console.error("Error searching patients:", error);
      // Fallback to regular getPatients
      return await orderService.getPatients(searchQuery, 0, limit);
    }
  },

  // ===== PHYSICIAN OPERATIONS =====

  getPhysicians: async (search = "", skip = 0, limit = 100) => {
    try {
      const params = { search, skip, limit };
      const response = await apiService.get("/physicians", { params });
      return response.data;
    } catch (error) {
      console.error("Error fetching physicians:", error);

      // Fallback data
      return [
        {
          id: 1,
          first_name: "Dr. Sarah",
          last_name: "Johnson",
          specialty: "Cardiology",
          npi: "1234567890",
          phone_number: "(555) 111-2222",
          email: "dr.johnson@hospital.com",
          facility_name: "General Hospital",
        },
        {
          id: 2,
          first_name: "Dr. Michael",
          last_name: "Brown",
          specialty: "Internal Medicine",
          npi: "0987654321",
          phone_number: "(555) 333-4444",
          email: "dr.brown@clinic.com",
          facility_name: "City Clinic",
        },
        {
          id: 3,
          first_name: "Dr. Lisa",
          last_name: "Davis",
          specialty: "Family Medicine",
          npi: "1122334455",
          phone_number: "(555) 555-6666",
          email: "dr.davis@clinic.com",
          facility_name: "Family Health Center",
        },
      ].filter(
        (physician) =>
          !search ||
          physician.first_name.toLowerCase().includes(search.toLowerCase()) ||
          physician.last_name.toLowerCase().includes(search.toLowerCase()) ||
          (physician.specialty &&
            physician.specialty.toLowerCase().includes(search.toLowerCase()))
      );
    }
  },

  createPhysician: async (physicianData) => {
    try {

      // Validate required fields
      if (
        !physicianData.first_name?.trim() ||
        !physicianData.last_name?.trim()
      ) {
        throw new Error("First and last name are required");
      }

      // Clean the data
      const cleanedData = {
        ...physicianData,
        first_name: physicianData.first_name.trim(),
        last_name: physicianData.last_name.trim(),
        npi: physicianData.npi?.trim() || null,
        facility_name: physicianData.facility_name?.trim() || null,
        phone_number: physicianData.phone_number?.trim() || null,
        email: physicianData.email?.trim().toLowerCase() || null,
      };

      const response = await apiService.post("/physicians", cleanedData);
      return response.data;
    } catch (error) {
      console.error("Error creating physician:", error);

      // Handle specific error types
      if (error.response?.status === 409) {
        throw new Error("A physician with this NPI already exists");
      } else if (error.response?.status === 422) {
        const details = error.response.data?.detail;
        if (Array.isArray(details)) {
          const errorMessages = details.map((err) => err.msg).join(", ");
          throw new Error(`Validation error: ${errorMessages}`);
        } else {
          throw new Error(`Validation error: ${details || "Invalid data"}`);
        }
      }

      throw new Error(`Failed to create physician: ${error.message}`);
    }
  },

  // ===== REFERENCE DATA =====

  getExamTypes: async () => {
    try {
      const response = await apiService.get("/exam-types");
      return response.data;
    } catch (error) {
      console.error("Error fetching exam types:", error);

      // Fallback exam types
      return [
        {
          id: 1,
          name: "Blood Draw",
          description: "Standard blood collection",
          category: "Laboratory",
          is_active: true,
        },
        {
          id: 2,
          name: "ECG",
          description: "Electrocardiogram",
          category: "Cardiac",
          is_active: true,
        },
        {
          id: 3,
          name: "Blood Pressure Check",
          description: "Blood pressure measurement",
          category: "Vital Signs",
          is_active: true,
        },
        {
          id: 4,
          name: "Wound Care",
          description: "Wound cleaning and dressing",
          category: "Nursing",
          is_active: true,
        },
        {
          id: 5,
          name: "Medication Administration",
          description: "Injection or IV medication",
          category: "Nursing",
          is_active: true,
        },
        {
          id: 6,
          name: "Post-Op Check",
          description: "Post-operative care and monitoring",
          category: "Nursing",
          is_active: true,
        },
      ];
    }
  },

  createExamType: async (examData) => {
    try {
      const response = await apiService.post("/orders/exam-types", examData);
      return response.data;
    } catch (error) {
      console.error("Error creating exam type:", error);
      throw new Error(`Failed to create exam type: ${error.message}`);
    }
  },

  // FIXED: Enhanced getDiagnoses with better error handling and fallback
  getDiagnoses: async (search = "") => {
    try {

      const params = search.trim() ? { search: search.trim() } : {};
      const response = await apiService.get("/diagnoses", { params });


      if (!response.data) {
        console.warn("No diagnosis data received, using fallback");
        return orderService._getFallbackDiagnoses(search);
      }

      const diagnoses = Array.isArray(response.data) ? response.data : [];

      if (diagnoses.length === 0 && !search) {
        console.warn("No diagnoses found, using fallback");
        return orderService._getFallbackDiagnoses(search);
      }

      return diagnoses;
    } catch (error) {
      console.error("Error fetching diagnoses:", error);

      console.warn(
        "Using fallback diagnosis data due to error:",
        error.message
      );
      return orderService._getFallbackDiagnoses(search);
    }
  },

  // FIXED: Enhanced fallback diagnoses
  _getFallbackDiagnoses: (search = "") => {
    const fallbackDiagnoses = [
      {
        id: 1,
        code: "I10",
        description: "Essential hypertension",
        category: "Cardiovascular",
      },
      {
        id: 2,
        code: "E11.9",
        description: "Type 2 diabetes mellitus without complications",
        category: "Endocrine",
      },
      {
        id: 3,
        code: "M79.3",
        description: "Panniculitis, unspecified",
        category: "Musculoskeletal",
      },
      {
        id: 4,
        code: "Z51.11",
        description: "Encounter for antineoplastic chemotherapy",
        category: "Treatment",
      },
      {
        id: 5,
        code: "Z00.00",
        description:
          "Encounter for general adult medical examination without abnormal findings",
        category: "Screening",
      },
      {
        id: 6,
        code: "R50.9",
        description: "Fever, unspecified",
        category: "Symptoms",
      },
      {
        id: 7,
        code: "J06.9",
        description: "Acute upper respiratory infection, unspecified",
        category: "Respiratory",
      },
      {
        id: 8,
        code: "K59.00",
        description: "Constipation, unspecified",
        category: "Digestive",
      },
      {
        id: 9,
        code: "M25.50",
        description: "Pain in unspecified joint",
        category: "Musculoskeletal",
      },
      {
        id: 10,
        code: "R06.02",
        description: "Shortness of breath",
        category: "Respiratory",
      },
    ];

    if (!search || !search.trim()) {
      return fallbackDiagnoses;
    }

    const searchTerm = search.toLowerCase().trim();
    return fallbackDiagnoses.filter(
      (diagnosis) =>
        diagnosis.code.toLowerCase().includes(searchTerm) ||
        diagnosis.description.toLowerCase().includes(searchTerm) ||
        diagnosis.category.toLowerCase().includes(searchTerm)
    );
  },

  createDiagnosis: async (diagnosisData) => {
    try {
      const response = await apiService.post(
        "/orders/diagnoses",
        diagnosisData
      );
      return response.data;
    } catch (error) {
      console.error("Error creating diagnosis:", error);
      throw new Error(`Failed to create diagnosis: ${error.message}`);
    }
  },

  // ===== DASHBOARD & STATISTICS =====

  getDashboardStats: async () => {
    try {
      const response = await apiService.get("/orders/dashboard-stats");
      return response.data;
    } catch (error) {
      console.error("Error fetching dashboard stats:", error);

      // Fallback to manual calculation
      try {
        const orders = await orderService.getAllOrders({ limit: 1000 });
        const today = new Date().toISOString().split("T")[0];

        return {
          total_orders: orders.length,
          created_orders: orders.filter((o) => o.status === "created").length,
          assigned_orders: orders.filter((o) => o.status === "assigned").length,
          in_progress_orders: orders.filter((o) => o.status === "in_progress")
            .length,
          completed_orders: orders.filter((o) => o.status === "completed")
            .length,
          cancelled_orders: orders.filter((o) => o.status === "cancelled")
            .length,
          today_orders: orders.filter((o) => {
            const orderDate = new Date(o.created_at)
              .toISOString()
              .split("T")[0];
            return orderDate === today;
          }).length,
        };
      } catch (fallbackError) {
        return {
          total_orders: 0,
          created_orders: 0,
          assigned_orders: 0,
          in_progress_orders: 0,
          completed_orders: 0,
          cancelled_orders: 0,
          today_orders: 0,
        };
      }
    }
  },

  getPatientStats: async (patientId) => {
    try {
      const response = await apiService.get(`/patients/${patientId}/stats`);
      return response.data;
    } catch (error) {
      console.error("Error fetching patient stats:", error);

      // Fallback calculation
      try {
        const orders = await orderService.getAllOrders({
          patient_id: patientId,
        });
        return {
          patient_id: patientId,
          total_orders: orders.length,
          completed_orders: orders.filter((o) => o.status === "completed")
            .length,
          cancelled_orders: orders.filter((o) => o.status === "cancelled")
            .length,
          pending_orders: orders.filter(
            (o) => !["completed", "cancelled"].includes(o.status)
          ).length,
          last_order_date:
            orders.length > 0
              ? new Date(
                  Math.max(
                    ...orders.map((o) => new Date(o.created_at).getTime())
                  )
                ).toISOString()
              : null,
          first_order_date:
            orders.length > 0
              ? new Date(
                  Math.min(
                    ...orders.map((o) => new Date(o.created_at).getTime())
                  )
                ).toISOString()
              : null,
          completion_rate:
            orders.length > 0
              ? (orders.filter((o) => o.status === "completed").length /
                  orders.length) *
                100
              : 0,
        };
      } catch (fallbackError) {
        return {
          patient_id: patientId,
          total_orders: 0,
          completed_orders: 0,
          cancelled_orders: 0,
          pending_orders: 0,
          last_order_date: null,
          first_order_date: null,
          completion_rate: 0,
        };
      }
    }
  },

  getPatientOrders: async (patientId, skip = 0, limit = 50) => {
    try {
      const params = { skip, limit };
      const response = await apiService.get(`/patients/${patientId}/orders`, {
        params,
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching patient orders:", error);

      // Fallback to filtering all orders
      try {
        const allOrders = await orderService.getAllOrders({ limit: 1000 });
        return allOrders.filter(
          (order) => order.patient_id === parseInt(patientId)
        );
      } catch (fallbackError) {
        return [];
      }
    }
  },

  // ===== VALIDATION HELPERS =====

  validatePatientData: (patientData) => {
    const errors = {};

    // Required fields validation
    if (!patientData.first_name?.trim()) {
      errors.first_name = "First name is required";
    } else if (patientData.first_name.trim().length < 2) {
      errors.first_name = "First name must be at least 2 characters";
    }

    if (!patientData.last_name?.trim()) {
      errors.last_name = "Last name is required";
    } else if (patientData.last_name.trim().length < 2) {
      errors.last_name = "Last name must be at least 2 characters";
    }

    if (!patientData.address?.trim()) {
      errors.address = "Address is required";
    }

    if (!patientData.city?.trim()) {
      errors.city = "City is required";
    }

    if (!patientData.state?.trim()) {
      errors.state = "State is required";
    }

    if (!patientData.zip_code?.trim()) {
      errors.zip_code = "ZIP code is required";
    } else if (!/^\d{5}(-\d{4})?$/.test(patientData.zip_code.trim())) {
      errors.zip_code = "ZIP code must be in format 12345 or 12345-6789";
    }

    // Optional field validation
    if (
      patientData.phone_number &&
      !/^\+?[\d\s\-\(\)]+$/.test(patientData.phone_number)
    ) {
      errors.phone_number = "Invalid phone number format";
    }

    if (
      patientData.email &&
      !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(patientData.email)
    ) {
      errors.email = "Invalid email format";
    }

    if (patientData.date_of_birth) {
      const birthDate = new Date(patientData.date_of_birth);
      const today = new Date();
      if (birthDate > today) {
        errors.date_of_birth = "Date of birth cannot be in the future";
      }

      const age = today.getFullYear() - birthDate.getFullYear();
      if (age > 150) {
        errors.date_of_birth = "Please check the date of birth";
      }
    }

    return {
      isValid: Object.keys(errors).length === 0,
      errors,
    };
  },

  // ===== ADVANCED ADMIN FEATURES =====

  // Get edit permissions for an order
  getOrderEditPermissions: async (orderId) => {
    try {
      const response = await apiService.get(
        `/orders/${orderId}/edit-permissions`
      );
      return response.data;
    } catch (error) {
      console.error("Error getting edit permissions:", error);
      if (error.response?.status === 404) {
        throw new Error("Order not found");
      } else if (error.response?.status === 403) {
        throw new Error("You don't have permission to access this order");
      }
      throw new Error(`Failed to get edit permissions: ${error.message}`);
    }
  },

  // Check if user can edit an order in its current status
  canEditOrder: async (orderId) => {
    try {
      const permissions = await orderService.getOrderEditPermissions(orderId);
      return {
        canEdit: permissions.can_edit_basic || permissions.can_edit_in_progress,
        canForceEdit: permissions.can_force_edit,
        requiresForceEdit: permissions.requires_force_edit,
        editableFields: permissions.editable_fields,
        editableSections: permissions.editable_sections,
        orderStatus: permissions.order_status,
        userRole: permissions.user_role,
        editReason: permissions.edit_reason,
      };
    } catch (error) {
      console.error("Error checking edit permissions:", error);
      return {
        canEdit: false,
        canForceEdit: false,
        requiresForceEdit: true,
        editableFields: [],
        editableSections: [],
        orderStatus: "unknown",
        userRole: "unknown",
        editReason: "Permission check failed",
      };
    }
  },

  // Get order edit history/audit log
  getOrderEditHistory: async (orderId) => {
    try {
      const response = await apiService.get(`/orders/${orderId}/edit-history`);
      return response.data;
    } catch (error) {
      console.error("Error getting edit history:", error);
      // Return empty history if endpoint doesn't exist
      if (error.response?.status === 404) {
        return [];
      }
      throw new Error(`Failed to get edit history: ${error.message}`);
    }
  },

  // ===== UTILITY FUNCTIONS =====

  // Helper function to format update data for API
  formatUpdateData: (formData, editType = "standard") => {
    const updateData = {};

    // Format patient data
    if (formData.patient_data) {
      updateData.patient_data = { ...formData.patient_data };
      // Clean up empty strings and convert to null
      Object.keys(updateData.patient_data).forEach((key) => {
        if (updateData.patient_data[key] === "") {
          updateData.patient_data[key] = null;
        }
      });
    }

    // Format physician data
    if (formData.physician_data) {
      updateData.physician_data = { ...formData.physician_data };
      // Clean up empty strings
      Object.keys(updateData.physician_data).forEach((key) => {
        if (updateData.physician_data[key] === "") {
          updateData.physician_data[key] = null;
        }
      });
    }

    // Format order fields
    const orderFields = [
      "place_of_service",
      "ordering_health_company",
      "scheduled_date",
      "scheduled_time",
      "special_notes",
    ];
    orderFields.forEach((field) => {
      if (formData[field] !== undefined) {
        updateData[field] = formData[field] === "" ? null : formData[field];
      }
    });

    // FIXED: Format diagnoses with proper structure
    if (formData.selected_diagnoses) {
      updateData.diagnoses = formData.selected_diagnoses.map(
        (diagnosis, index) => ({
          diagnosis_id: diagnosis.diagnosis_id || diagnosis.id,
          primary: index === 0,
        })
      );
    }

    // FIXED: Format exams with proper structure
    if (formData.selected_exams) {
      updateData.exams = formData.selected_exams.map((exam) => ({
        exam_type_id: exam.id,
      }));
    }

    return updateData;
  },

  // ===== PRIVATE HELPER FUNCTIONS =====

  // Fallback data for development
  _getFallbackPatients: (search = "") => {
    const fallbackPatients = [
      {
        id: 1,
        first_name: "John",
        last_name: "Doe",
        date_of_birth: "1980-01-15",
        gender: "Male",
        phone_number: "(555) 123-4567",
        email: "john.doe@email.com",
        address: "123 Main Street",
        address_notes: "Apt 2B",
        city: "Los Angeles",
        state: "CA",
        zip_code: "90210",
        medical_record_number: "MRN001",
        created_at: new Date().toISOString(),
      },
      {
        id: 2,
        first_name: "Jane",
        last_name: "Smith",
        date_of_birth: "1975-08-22",
        gender: "Female",
        phone_number: "(555) 987-6543",
        email: "jane.smith@email.com",
        address: "456 Oak Avenue",
        address_notes: "House",
        city: "Beverly Hills",
        state: "CA",
        zip_code: "90212",
        medical_record_number: "MRN002",
        created_at: new Date().toISOString(),
      },
      {
        id: 3,
        first_name: "Maria",
        last_name: "Garcia",
        date_of_birth: "1990-03-10",
        gender: "Female",
        phone_number: "(555) 555-0123",
        email: "maria.garcia@email.com",
        address: "789 Pine Street",
        address_notes: "Unit 5",
        city: "Santa Monica",
        state: "CA",
        zip_code: "90401",
        medical_record_number: "MRN003",
        created_at: new Date().toISOString(),
      },
    ];

    if (!search || !search.trim()) {
      return fallbackPatients;
    }

    const searchTerm = search.toLowerCase();
    return fallbackPatients.filter(
      (patient) =>
        patient.first_name.toLowerCase().includes(searchTerm) ||
        patient.last_name.toLowerCase().includes(searchTerm) ||
        patient.address.toLowerCase().includes(searchTerm) ||
        patient.medical_record_number?.toLowerCase().includes(searchTerm) ||
        patient.phone_number?.includes(searchTerm) ||
        patient.email?.toLowerCase().includes(searchTerm)
    );
  },
};
